<template>
  <div class="dashboard">
    <div class="coming-soon">
      <i class="el-icon-construction"></i>
      <h2>待开发</h2>
      <p>敬请期待</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dashboard'
}
</script>

<style scoped>
.dashboard {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 80px);
  background-color: #f5f7fa;
}

.coming-soon {
  text-align: center;
  padding: 60px;
}

.coming-soon i {
  font-size: 120px;
  color: #c0c4cc;
  margin-bottom: 30px;
}

.coming-soon h2 {
  font-size: 32px;
  color: #303133;
  margin: 0 0 15px 0;
  font-weight: 600;
}

.coming-soon p {
  font-size: 18px;
  color: #909399;
  margin: 0;
}

@media (max-width: 768px) {
  .coming-soon i {
    font-size: 80px;
  }
  
  .coming-soon h2 {
    font-size: 24px;
  }
  
  .coming-soon p {
    font-size: 16px;
  }
}
</style>
